export const ROUTES = {
  DEFAULT: "/",
  NEW_PASSWORD: "/new-password",
  ONBOARDING: "/onboarding",
  EVENTS: "/events",
  CREATE_EVENT: "/create-event",
  ORGANIZATION: "/organization",
  ABOUT: "/about",
  EVENT: "/event-statistics",
  LOGS: "/logs",
  MANAGE_EVENT: "/event-management",
  CUSTOMER_PROFILE: "/customer-profile/:ref",
  CUSTOMIZE_EVENT: "/customize-event",
  ONBOARDING_ORGANIZER: "/onboard-organizer",
};
